// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"dbffd2e1","994":"5cdbaae8"}[chunkId] + ".chunk.css";
};